import { NavLink } from 'react-router';
import { useAppStore } from '@app/store/useAppStore';
import styles from './BottomTabBar.module.css';

const KEY_DEPENDENT = new Set(['/chords', '/scales', '/progressions']);

const ITEMS: { to: string; label: string; icon: string }[] = [
  { to: '/', label: 'Key', icon: '◐' },
  { to: '/chords', label: 'Chords', icon: '♫' },
  { to: '/scales', label: 'Scales', icon: '\u{1D11E}' },
  { to: '/progressions', label: 'Prog', icon: '⇨' },
  { to: '/settings', label: 'Settings', icon: '⚙' },
];

interface Props {
  orientation?: 'horizontal' | 'vertical';
}

export function BottomTabBar({ orientation = 'horizontal' }: Props) {
  const hasKey = Boolean(useAppStore((s) => s.selectedKeyId));
  return (
    <nav
      className={[styles.bar, orientation === 'vertical' ? styles.vertical : styles.horizontal]
        .filter(Boolean)
        .join(' ')}
      aria-label="Primary"
    >
      {ITEMS.map((item) => {
        const disabled = KEY_DEPENDENT.has(item.to) && !hasKey;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              [styles.tab, isActive && styles.active, disabled && styles.disabled]
                .filter(Boolean)
                .join(' ')
            }
            aria-disabled={disabled || undefined}
            onClick={(e) => {
              if (disabled) e.preventDefault();
            }}
          >
            <span className={styles.icon} aria-hidden>
              {item.icon}
            </span>
            <span className={styles.label}>{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
